import { useMemo, useState } from 'react'
import {
  Box,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
} from '@material-ui/core'
import { Paper, Table } from '@/components/index'
import { AspectRatio } from '@material-ui/icons'

//----------------------utils-------------------//

const sortAndRank = (data, limit = 10) =>
  Object.entries(data)
    .sort(([, itemA], [, itemB]) => itemB - itemA)
    .slice(0, limit)
    .map(([key, count], index) => ({ key, count, rank: index + 1 }))

//----------------------------------------------//

export const RankingTable = ({
  invetoryLogs,
  userCount,
  productCount,
  searchApiType,
}) => {
  const [openDialog, setOpenDialog] = useState(false)

  const productsRanking = useMemo(
    () => sortAndRank(productCount),
    [productCount]
  )
  const companyRanking = useMemo(
    () => sortAndRank(userCount, 9999),
    [userCount]
  )

  return (
    <Box
      display="grid"
      gap={2}
      mt={6}
      sx={{
        gridTemplateColumns: {
          xs: 'repeat(1, 1fr)',
          md: 'repeat(2, 1fr)',
        },
      }}
    >
      <Box>
        <Box
          style={{
            display: 'flex',
            alignItems: 'end',
            gap: '0.5rem',
          }}
        >
          <Typography variant="h6" color="primary">
            Ranking - 10 empresas com mais consultas
          </Typography>
          <IconButton size="small" onClick={() => setOpenDialog(true)}>
            <Tooltip title="Ver lista completa">
              <AspectRatio color="primary" fontSize="medium" />
            </Tooltip>
          </IconButton>
        </Box>

        <Paper style={{ margin: 12 }}>
          <Table
            size="medium"
            data={companyRanking.slice(0, 10)}
            columns={[
              { title: '#', field: 'rank' },
              { title: 'EMPRESA', field: 'key' },
              { title: 'CONSULTAS', field: 'count', align: 'center' },
            ]}
          />
        </Paper>

        {/* Complete list */}
        <Dialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle style={{ color: '#607D8B' }}>
            Ranking - Empresas com mais consultas
          </DialogTitle>
          <DialogContent style={{ padding: '1rem' }}>
            <Table
              size="medium"
              data={companyRanking}
              columns={[
                { title: '#', field: 'rank' },
                { title: 'EMPRESA', field: 'key' },
                { title: 'CONSULTAS', field: 'count', align: 'center' },
              ]}
            />
          </DialogContent>
        </Dialog>
      </Box>

      {searchApiType === 'by_product' && (
        <Box>
          <Typography variant="h6" color="primary" style={{ marginLeft: 12 }}>
            Ranking - 10 produtos mais buscados
          </Typography>
          <Paper style={{ margin: 12 }}>
            <Table
              size="medium"
              data={productsRanking}
              columns={[
                { title: '#', field: 'rank' },
                { title: 'PRODUTO', field: 'key' },
                { title: 'CONSULTAS', field: 'count', align: 'center' },
              ]}
            />
          </Paper>
        </Box>
      )}
    </Box>
  )
}
